import React, { Component } from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import Amplify from '@aws-amplify/core';
import Auth from '@aws-amplify/auth';
import * as log from "loglevel";
import Login from "./Login";
import setLanguageAction from "COMPONENTS/CommonComponents/ChangeLanguage/setLanguageAction";
import { loginAction, leaveSessionAction, logoutAction } from "CONFIG/ActionFactory";
import { USER_ROLES, CONFIG } from "../../Utils/Constants";
import { selectUserRole, selectToken } from "../Whiteboard/selectors";
import { changeLanguage, getMessage, resetResources} from "CONFIG/i18n";
import  toastr  from 'COMPONENTS/ShowTostr/ShowTostr';
import { removeTrailingSlash,getURLParameter } from "../../Utils/Utility";
import { getTimeInMillisec } from "UTILS/DateUtils";

export class LoginContainer extends Component {
  constructor(props) {
    super(props);
    log.setLevel("error");
  }
  
  state = {
    networkError: "",
    roleByPath: "",
    isMfaSetup:false,
    mfaSecretKey: "",
    qrCodeUrl: "",
    mfaToken: "",
    mfaLoginResponse: null,
    isMfaLogin:false,
    isShowMfaErrorScreen: false,
    isShowMfaEnableScreen: false,
    isResetQrCodeTimer: false,
  };

  componentDidMount() {
    let loginPath = removeTrailingSlash(this.props.location.pathname).toLowerCase();
    this.setRoleByPath(loginPath);
    resetResources();
    /*
    if (CONFIG.path.superAdminLogin === loginPath) {
      this.props.setLanguageAction("en");
      changeLanguage();
    }
    */
    if (this.props.token) {
      switch (this.props.role) {
        case USER_ROLES.SUPER_ADMIN:
          if (CONFIG.path.superAdminLogin === loginPath)
            this.props.history.push(CONFIG.path.superAdmin)
          else
            logoutAction.logoutAction();
          break;
        case USER_ROLES.ADMIN:
          if (CONFIG.path.adminLogin === loginPath)
            this.props.history.push(CONFIG.path.admin)
          else
            logoutAction.logoutAction();
          break;
        case USER_ROLES.AGENT:
          if (CONFIG.path.login === loginPath ||
            CONFIG.path.login === this.props.location.pathname.toLowerCase())
            this.props.history.push(CONFIG.path.createSession)
          else
            logoutAction.logoutAction();
          break;
      }
    }
    leaveSessionAction.logoutUser();
    // we need to fetch SSOInfo again when user lands on Login after logout 
    // since we have cleared the entire sessionStorage above (line #54) on LoginContainer mount
    if(this.props.role !== USER_ROLES.SUPER_ADMIN ) {
      this.getSSOInfo();
    }
  }

  getSSOInfo = () => {
    let urlPath = removeTrailingSlash(window.location.pathname).split("/");

    // get sso info api should not get called for superadmin path
    if((urlPath[1] && urlPath[1].toLowerCase() === 'superadmin') 
    || (urlPath[2] && urlPath[2].toLowerCase() === 'superadmin')) {
      return;
    }

    // At first, urlPath[1] is nothing.
    if (urlPath[1]) {
      loginAction.getSSOInfo(urlPath[1]).then((response) => {
        if (response.uriIdentifier !== (this.props.uriIdentifier.replace("/", ''))) {
          loginAction.setURIidentifier('/' + response.uriIdentifier);
        }
        loginAction.setRoleByPath(urlPath[2] === 'admin' ? USER_ROLES.ADMIN : USER_ROLES.AGENT)
        if (response.ssoDetails.isSSOEnabled && !this.props.token && !getURLParameter("error")
          && getURLParameter("sso") !== "false") {
          console.log(`timestamp: Calling SSO Login at ${getTimeInMillisec()}, milliseconds: ${new Date().getTime()}`);
          // Save the key, if it is.
          if (window.location.search && window.location.search.includes("key")) {
            sessionStorage.setItem("keyForSV", window.location.search.split("=")[1]);
          }
          // Firefox takes time to load sessionStorage (reducer), hence we've to set timeout here 
          // to load URI-identifier in the reducer. This URI-identifier is required on SSO-callback
          setTimeout(() => this.ssoLoginWithCognito(), 1500);
        }
      }).catch(() => {
        loginAction.setURIidentifier('/');
      });
    }
  }

  ssoLoginWithCognito = () => {
    try {
      const uriIdentifier = this.props.uriIdentifier.split("/")[1] ? this.props.uriIdentifier : "";
      Amplify.configure({
        Auth: {
          userPoolId: this.props.ssoDetails.userPoolId ,
          userPoolWebClientId: this.props.ssoDetails.clientId,
          oauth: {
            domain: this.props.ssoDetails.cognitoDomain,
            responseType: 'code',
            redirectSignIn: window.location.origin + uriIdentifier + CONFIG.path.ssoLogin,
            redirectSignOut: window.location.origin + uriIdentifier + CONFIG.path.ssoLogout
          }
        }
      });
      console.log('federatedSignIn');
      Auth.federatedSignIn({provider: this.props.ssoDetails.identityProvider});
    } catch (error) {
      console.log('error signing in with cognito', error);
      toastr.error(getMessage("INTERNAL_SERVER_ERROR"));
      if (window.location.pathname === this.props.uriIdentifier + CONFIG.path.adminLogin) {
        this.setState({ roleByPath: USER_ROLES.ADMIN }); 
      }
      else {
        this.setState({ roleByPath: USER_ROLES.AGENT });
      }
    }
  }

  setRoleByPath = (loginPath) => {
    let roleByPath = null;
    switch (loginPath) {
      case CONFIG.path.adminLogin:
        roleByPath = USER_ROLES.ADMIN;
        break;
      case CONFIG.path.superAdminLogin:
        roleByPath = USER_ROLES.SUPER_ADMIN;
        break;
      default:
        roleByPath = USER_ROLES.AGENT;
        break;
    }
    console.log("SSO debug: roleByPath:", roleByPath, ", loginPath:", loginPath);
    this.setState({ roleByPath: roleByPath });
  };

  UNSAFE_componentWillReceiveProps(nextProps) {

    if (nextProps.location.pathname !== this.props.location.pathname) {
      let pathname = removeTrailingSlash(nextProps.location.pathname).toLowerCase();
      this.setRoleByPath(pathname);
      /*
      if (CONFIG.path.superAdminLogin === pathname) {
        this.props.setLanguageAction("en");
        changeLanguage();
      }
      */
    }
  }

  handleLoginClick = userDetails => {
    this.setState({
      networkError: ""
    });
    loginAction.loginAction(userDetails).then(
      data => {
        if ( "mfa" in data.data ) {
          if (data.data.mfa.role != this.state.roleByPath) {
            this.setState({networkError: "INCORRECT_ROLE"});
            return;
          }
          if ( "key" in data.data.mfa ) {
            // show mfa setup screen
            this.setState({
              isMfaSetup: true,
              mfaSecretKey: data.data.mfa.key,
              qrCodeUrl: data.data.mfa.url,
              mfaToken: data.data.mfa.token,
              isResetQrCodeTimer: false,
            });
          } else {
            // show mfa login screen
            this.setState({
              isMfaLogin: true,
              mfaToken: data.data.mfa.token,
            });
          }
        } else {
          this.loginSuccess(data);
        }
      },
      err => {
        if (err.code == "MFA_ERROR_LOCK_CREDENTIALS") {
          this.setState({
            isShowMfaErrorScreen: true
          });
        }
        this.setState({
          networkError: err.code
        });
      }
    );
  };

  loginSuccess = (data) =>{
    let { role } = data.data.userDetails;
    if (!data.error) {
      switch (role) {
        case USER_ROLES.SUPER_ADMIN:
          this.state.roleByPath === USER_ROLES.SUPER_ADMIN
            ? this.props.history.push(CONFIG.path.superAdmin)
            : this.setState({
              networkError: "INCORRECT_ROLE"
            }, () => logoutAction.logoutreducerAction())
          break;
        case USER_ROLES.ADMIN:
          this.state.roleByPath === USER_ROLES.ADMIN
            ? this.props.history.push(CONFIG.path.admin)
            : this.setState({
              networkError: "INCORRECT_ROLE"
            }, () => logoutAction.logoutreducerAction())
          break;
        case USER_ROLES.AGENT:
          this.state.roleByPath === USER_ROLES.AGENT
            ? this.props.history.push(CONFIG.path.createSession)
            : this.setState({
              networkError: "INCORRECT_ROLE"
            }, () => logoutAction.logoutreducerAction());
          break;
      }
    }
  }

  handleMfaClick = (mfaKey, mfaToken, isSetup = false) => {
    this.setState({
      networkError: ""
    });
    const requestMfaLogin = {
      otp: mfaKey,
    }
    if (isSetup) {
      requestMfaLogin["setup"] = null;
    }
    loginAction.loginMfaAction(requestMfaLogin, mfaToken).then(
      data => {
        this.setState({
          isResetQrCodeTimer: true,
        })
        if (isSetup) {
          this.setState({
            isShowMfaEnableScreen: true,
            mfaLoginResponse: data,
          })
        } else {
          this.loginSuccess(data);
        }

      },
      err => {
        switch (err.code) {
          case "MFA_ERROR_ALREADY_AUTHED":
          case "MFA_ERROR_TIMED_OUT":
          case "MFA_ERROR_LOCK_CREDENTIALS":
          case "MFA_ERROR_NOT_AUTHORIZED":
          case "MFA_ERROR_INVALID_MFA_INFO":
          case "INVALID_USER":
            this.setState({
              isResetQrCodeTimer: true,
              isShowMfaErrorScreen: true
            });
            break;
        }
        this.setState({
          networkError: err.code
        });
      }
    );
  };

  handleShowMfaErrorScreen = (errorMsg) => {
    this.setState({
      networkError: errorMsg,
      isShowMfaErrorScreen: true,
      isResetQrCodeTimer: true,
    });
  };

  handleMfaBackToLoginClick = () => {
    this.setState({
      networkError: "",
      isMfaSetup: false,
      isMfaLogin: false,
      isShowMfaErrorScreen: false,
      mfaSecretKey: "",
      qrCodeUrl: "",
      isResetQrCodeTimer: true,
    });
  };

  handleMfaEnableOkClick = (data) => {
    this.setState({
      networkError: "",
      isMfaSetup: false,
      isMfaLogin: false,
      isShowMfaErrorScreen: false,
      mfaSecretKey: "",
      qrCodeUrl: "",
      isResetQrCodeTimer: true,
    });
    this.loginSuccess(data);
  };

  render() {
    return (
      <>
        <Login
          uriIdentifier={this.props.uriIdentifier}
          ssoDetails={this.props.ssoDetails}
          handleLoginClick={this.handleLoginClick}
          setLanguageAction={this.props.setLanguageAction}
          language={this.props.language}
          networkError={this.state.networkError}
          roleByPath={this.state.roleByPath}
          history={this.props.history}
          ssoLoginWithCognito={this.ssoLoginWithCognito}
          isMfaSetup={this.state.isMfaSetup}
          qrCodeUrl={this.state.qrCodeUrl}
          mfaSecretKey={this.state.mfaSecretKey}
          mfaToken={this.state.mfaToken}
          mfaLoginResponse={this.state.mfaLoginResponse}
          isMfaLogin={this.state.isMfaLogin}
          isShowMfaErrorScreen={this.state.isShowMfaErrorScreen}
          isShowMfaEnableScreen={this.state.isShowMfaEnableScreen}
          handleMfaClick={this.handleMfaClick}
          handleMfaBackToLoginClick={this.handleMfaBackToLoginClick}
          handleMfaEnableOkClick={this.handleMfaEnableOkClick}
          handleShowMfaErrorScreen={this.handleShowMfaErrorScreen}
          isResetQrCodeTimer={this.state.isResetQrCodeTimer}
        />
      </>
    );
  }
}

const mapStateToProps = state => {
  return {
    SessionReducer: state.SessionReducer,
    ssoDetails: state.UserReducer.ssoDetails,
    language: state.LanguageReducer.language,
    role: selectUserRole(state),
    token: selectToken(state),
    uriIdentifier: state.UserReducer.uriIdentifier
  };
};

const mapDispatchToProps = dispatch => {
  return bindActionCreators({ setLanguageAction }, dispatch);
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(LoginContainer);
